<template>
    <div class="bottomInHeader" v-show="menuShow">
        <div
            v-for="(item, index) in userInfo.sys_codes"
            :key="item.sys_code"
            :class="
                item.sys_code == activeSys ? 'basicItem currentSys' : 'basicItem'
            "
            @click="changeSystem(item)"
        >
            <img
                :src="
                    item.sys_code == activeSys
                        ? item.selectImg
                        : item.img
                "
            />{{ item.sys_code_name }}
            <div class="split-line1" v-if="index == userInfo.sys_codes.length-1"></div>
        </div>
    </div>
</template>
<script>
export default {
    components: {},
    data() {
        return {
            activeSys: "", // 当前系统
            menuShow: true
        };
    },
    props: {
        menuType: String
    },
    computed: {
        userInfo() {
            let activeSys = sessionStorage.getItem("activeSys");
            if (activeSys) {
                this.activeSys = activeSys;
            } else {
                this.activeSys =
                    this.$store.state.login.userInfo.sys_codes &&
                    this.$store.state.login.userInfo.sys_codes[0].sys_code;
                sessionStorage.setItem("activeSys", this.activeSys);
            }

            return this.$store.state.login.userInfo;
        }
    },
    watch: {
        menuType: {
            handler(newValue) {
                this.menuType = sessionStorage.getItem("activeSys");
                if(this.menuType) this.activeSys = sessionStorage.getItem("activeSys");
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        routerGo(url) {
            this.$router.push(url);
        },
        /**
         * 切换系统
         */
        changeSystem(sysObject) {
            if (
                this.$store.state.login.userInfo &&
                this.$store.state.login.userInfo.user_type == "99"
            ) {
                // this.$parent.setMenuTimer();
                return;
            }
            // 临时的
            if (sysObject.sys_code == "80") {
                // 空调管理
                this.$router.push("/air_condition");
                this.activeSys = "80";
                sessionStorage.setItem("activeSys", "80");
                sessionStorage.removeItem("activeTab");
                this.$store.commit("IS_CHANGE_SYSTEM", true);
                return;
            } else if (sysObject.sys_code == "90") {
                // 消防管理
                this.$router.push("/fire_control");
                this.activeSys = "90";
                sessionStorage.setItem("activeSys", "90");
                sessionStorage.removeItem("activeTab");
                this.$store.commit("IS_CHANGE_SYSTEM", true);
                return;
            }

            this.activeSys = sysObject.sys_code;
            sessionStorage.setItem("activeSys", this.activeSys);
            sessionStorage.removeItem("activeTab");
            sessionStorage.removeItem("header-title");
            this.$store.commit("IS_CHANGE_SYSTEM", true);
            this.$store.dispatch("getMenuListByRoles", this.activeSys);
        },
        toggleMenu() {
            this.menuShow = !this.menuShow;
        }
    }
};
</script>
<style lang="scss">
.bottom ul {
    text-align: center;
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 0);
    width: 100%;
}
.bottom ul li {
    display: inline-block;
}
.bottomInHeader {
   display: inline-flex;
   color: #fff;
   margin-right: 1rem;
}
.bottom ul li a {
    display: block;
}
.bottom ul li a > div {
    font-size: px2Rem(16px);
    height: px2Rem(20px);
    line-height: px2Rem(20px);
    color: #56fcff;
    font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
        "Lucida Sans", Arial, sans-serif;
    // text-shadow: px2Rem(0.5px) px2Rem(0.5px) px2Rem(0.5px) #56fcff;
}
.currentSys {
    color: #ffb728 !important;
}
.basicItem {
    padding: 0 0 0 0.8rem;
    //border-right: 1px solid #56fcff;
    cursor: pointer;
    font-size: 0.7rem;
    img {
        height: 1.5rem;
    }
}
.split-line1 {
    width: 2px;
    height: 0.85rem;
    background: #56fcff;
    display: inline-block;
    margin: 0 0 0 0.5rem;
    vertical-align: middle;
}
.bottom ul li a > img {
    width: px2Rem(110px);
    height: px2Rem(80px);
}
.bottom-name {
    position: absolute;
    right: 20px;
    color: #56fcff;
    top: 10px;
}
.toggleIcon {
    position: fixed;
    bottom: px2Rem(20px);
    right: px2Rem(20px);
    cursor: pointer;
    color: #fff;
    i {
        font-size: px2Rem(30px);
    }
}
</style>
